<template>
  <div id="app">
    <div class="content-header">
      <h1>分化图列表</h1>
    </div>

    <div class="app-container">
      <el-table size="small" current-row-key="id" :data="dataList" stripe highlight-current-row>
        <el-table-column type="index" align="center" label="id"></el-table-column>
        <el-table-column prop="name" label="名称" align="center"></el-table-column>
        <el-table-column prop="order" label="排序" align="center"></el-table-column>
        <el-table-column prop="data" label="数据" align="center">
          <template slot-scope="scope">
            <el-link type="primary" @click="copyData(scope.row.data)"> 点击查看 </el-link>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button size="mini" type="primary" @click="editData(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="deleteData(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import axios from "@/axios";

export default {
  name: "DdImageInfo",
  data: function () {
    return {
      dataList: [], //当前页要展示的列表数据
    };
  },

  //钩子函数，VUE对象初始化完成后自动执行
  mounted() {
    //调用查询全部数据的操作
    this.getAll();
  },

  methods: {
    getAll() {
      axios.get("/sys/dd_image/info").then((res) => {
        this.dataList = res.data.data;
      });
    },
    editData(row) {
      //跳转时页面
      this.$router.push({
        path: "/sys/ddImage",
        query: {
          id: row.id,
        },
      });
    },
    deleteData(row) {
      this.$confirm("此操作将永久删除【" + row.name + "】, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios.post("/sys/dd_image/delete/" + row.id).then((res) => {
            this.$message.success(res.data.msg);
            if (res.data.code == "0000") {
              // 删除成功，重新刷新
              this.getAll();
            }
          });
        })
        .catch(() => {});
    },
    copyData(data) {
      const h = this.$createElement;
      this.$msgbox({
        title: "数据内容",
        message: h("div", { class: "x-x-scroll-bar" }, data),
        showCancelButton: true,
        confirmButtonText: "复制",
        cancelButtonText: "取消",
      })
        .then(() => {
          navigator.clipboard.writeText(data).then(
            () => {
              this.$message({
                type: "success",
                message: "复制成功!",
              });
            },
            () => {
              this.$message({
                type: "success",
                message: "复制失败，请尝试更新浏览器版本!",
              });
            }
          );
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped>
.x-x-scroll-bar {
  max-height: 400px;
  overflow-y: auto;
}

.x-x-scroll-bar::-webkit-scrollbar {
  width: 10px;
}

.x-x-scroll-bar::-webkit-scrollbar-track {
  background-color: #f1f1f1;
}

.x-x-scroll-bar::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 6px;
  border: 3px solid #f1f1f1;
}

.x-x-scroll-bar::-webkit-scrollbar-thumb:hover {
  background-color: #555;
}
</style>
